<div class="item-wrapper">
    @for (column of columns; track column) {
        @if (column.isDisplayed) {
            @switch (column.value) {
                @case ('type') {
                    <div class="field">
                        <span>{{ formTypeList | getFormType:template.formTypeSettings[column.value] }}</span>
                    </div>
                }
                @case ('category') {
                    <div class="field">
                        <span>{{ template.formTypeSettings[column.value] | getFormCategory }}</span>
                    </div>
                }
                @case ('owner') {
                    <div class="field">
                        <span>{{ template?.account?.name || 'RISE SMS' }}</span>
                    </div>
                }
                @default {
                    <div class="field">
                        <span>{{ template[column.value] }}</span>
                    </div>
                }
            }
        }
    }

    <div class="button-container">
        <button class="btn-tertiary-link" (click)="openPreview()">Preview</button>
        <button class="btn-secondary" (click)="clone()">Clone & Customize</button>
    </div>
</div>


<div class="item-wrapper-mobile">
    <app-flight-card-mobile [content]="'grid'">
        <ng-container title>
            {{template.title}}
        </ng-container>

        <ng-container content>
            @for (column of columns; track column) {
                @if (column.isDisplayed) {
                    @switch (column.value) {
                        @case ('title') {}
                        @case ('type') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ formTypeList | getFormType:template.formTypeSettings[column.value] }}</span>
                            </div>
                        }
                        @case ('category') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ template.formTypeSettings[column.value] | getFormCategory }}</span>
                            </div>
                        }
                        @case ('owner') {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{ template?.account?.name || 'RISE SMS' }}</span>
                            </div>
                        }
                        @default {
                            <div class="content-field flex flex-column">
                                <span class="font-bold">{{column.label}}</span>
                                <span>{{column.value}}</span>
                            </div>
                        }
                    }
                }
            }
        </ng-container>

        <ng-container actions>
            <div class="flex gap-3 w-full">
                <button class="btn-tertiary-link flex-1" (click)="openPreview()">Preview</button>
                <button class="btn-secondary flex-1" (click)="clone()">Clone & Customize</button>
            </div>
        </ng-container>
    </app-flight-card-mobile>
</div>
